module.exports = __webpack_public_path__ + "img/twism-full-logo.c7f5edc1.svg";